import { FIELD_TYPES } from "constants/template-field-type";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import { ButtonTypes } from "segments/desktop/grid/layouts/background-image-cards-grid/background-image-card/card-button/button-types";
import { PARAGRAPH_AND_ASSET_VIDEOS } from "constants/video-types";
import ThemeConfig from "segments/core-configs/theme-config";

const { mobileTextAlign, textColor, topic, buttonConfig, ...resOfParagraphConfig } = FullParagraphFieldsConfig;

const button = {
  type: FIELD_TYPES.CONDITIONAL_NESTED,
  label: "Button",
  conditionalKeyName: "buttonType",
  options: [
    {
      text: ButtonTypes.PRODUCT_SIGNUP_AND_LEARN_MORE,
      fieldsConfig: {
        productType: {
          label: "Product",
          type: FIELD_TYPES.PRODUCTS
        },
        buttonColor: { label: "Button color", type: FIELD_TYPES.COLOR_PICKER },
        invert: { label: "Invert", type: FIELD_TYPES.BOOLEAN },
        withArrow: { label: "With arrow", type: FIELD_TYPES.BOOLEAN }
      },
      type: FIELD_TYPES.NESTED
    },
    {
      text: ButtonTypes.LABEL,
      fieldsConfig: {
        text: {
          label: "Text",
          type: FIELD_TYPES.TEXT
        },
        borderColor: {
          label: "Border color",
          type: FIELD_TYPES.COLOR_PICKER
        }
      },
      type: FIELD_TYPES.NESTED
    }
  ]
};

export default {
  type: FIELD_TYPES.NESTED,
  label: "Background Image Cards",
  fields: {
    ...ThemeConfig,
    cardHeight: { type: FIELD_TYPES.TEXT, label: "Card Height" },
    cards: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Cards",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          backgroundImage: {
            type: FIELD_TYPES.GALLERY,
            label: "Fallback background image (if no video supplied)"
          },
          backgroundVideo: {
            type: FIELD_TYPES.CLOUDINARY_VIDEO_PICKER,
            label: "Background video (on hover)",
            videoType: PARAGRAPH_AND_ASSET_VIDEOS
          },
          paragraph: {
            type: FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: { topic: { ...topic, fields: { image: topic.fields.image } }, ...resOfParagraphConfig }
          },
          button
        }
      }
    }
  }
};
